module.exports = __webpack_public_path__ + "assets/img/bg1.63720734.png";